// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"3a688e29","703":"c2c19190"}[chunkId] + ".chunk.js";
};